import { useState } from 'react';
import CalendarView from '../../CalendarView';
import PracticeManagementWidget from '../PracticeManagementWidget';
import OnboardDoctor from '../OnboardDoctor';
import { useClinicData } from '../../utils/useClinicData';
import { useAuth } from '../../utils/AuthContext';

export default function AdminDashboard() {
    const { user, token } = useAuth();
    const { selectedClinic, selectedLocation, setSelectedLocation, filteredLocations, doctors, refreshDoctors } = useClinicData();
    const singleDoctor = doctors.length === 1? doctors[0] : null;
    const [onboardDoctor, setOnboardDoctor] = useState(false);
    return (
        <div>
            <section className='p-6'>
                <div className='flex justify-end'>
                    <img src='/assets/invoco_icon_transparent_purple.webp' alt='invoco icon' className='h-12 w-12' /> 
                </div>

                <div className='grid grid-cols-1 gap-3'>
                    {/* PRACTICE MANAGEMENT - ADMIN  */}
                    <div className='bg-white p-6 rounded shadow-md'>
                        <h1 className='text-2xl font-bold text-gray-700'>Practice Management</h1>
                        <PracticeManagementWidget clinicId={user.clinic_id}/>
                    </div>

                    {/* CALENDAR - ADMIN  */}
                    <div className='bg-white p-6 rounded shadow-md'>
                        <h1 className='text-2xl font-bold text-gray-700'>Calendar View</h1>
                        <div className='p-3 sm:flex-col'>
                        {selectedClinic && (
                            <select value={selectedLocation?.location_id || ''} onChange={(event) => setSelectedLocation(filteredLocations.find((location) => location.location_id === parseInt(event.target.value)))} className='rounded-md border p-2 mx-4'>
                                <option value='' disabled>-Select a Location-</option>
                                {filteredLocations.map((location) => (
                                    <option key={location.location_id} value={location.location_id}>
                                        {location.location_name}
                                    </option>
                                ))}
                            </select>
                        )}

                        {selectedLocation && (
                            <div>
                                {doctors.length === 0 ? (
                                    <p className='text-gray-700 font-semibold p-4'>
                                        No doctors registered yet for {selectedLocation.location_name}.
                                        <button onClick={() => setOnboardDoctor(true)} className='text-docpgrPurple border py-1 px-3 mx-4 rounded-lg hover:text-white hover:bg-docpgrPurple90 font-semibold bg-docpgrPurple10'>
                                            Register Doctor
                                        </button>
                                    </p>
                                ) : singleDoctor ? (
                                    <p className='text-gray-700 font-semibold p-4'>
                                        Only one doctor registered to {selectedLocation.location_name}. <span className='font-bold'>{singleDoctor.doctor_name}</span> will receive all notifications.
                                    </p>
                                ) : (
                                    <CalendarView clinicId={selectedClinic} clinicName={selectedClinic.clinic_name} location={selectedLocation} />
                                )}
                            </div>
                        )}
                        </div>
                    </div>
                </div>

                {onboardDoctor && (
                    <OnboardDoctor isOpen={onboardDoctor} onClose={() => setOnboardDoctor(false)} clinicId={selectedClinic} locationId={selectedLocation.location_id} token={token} onSuccess={refreshDoctors} userRole={user.role}/>
                )}

            </section>
        </div>
    )
}